// extracted by mini-css-extract-plugin
export default {"newResourcePopover":"NewResourcePopover_newResourcePopover__onCgj","dateWrapper":"NewResourcePopover_dateWrapper__L0a5H"};